import styled from '@emotion/styled';

const WizardCard = styled.div`
  ${({ theme }) => theme.mq('md')} {
    display: none;
  }
`;

const FullForm = styled.div`
  display: none;

  ${({ theme }) => theme.mq('md')} {
    display: block;
  }
`;

export { FullForm, WizardCard };
